var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeedometer01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.33008V3.83008M11 1.33008C5.47715 1.33008 1 5.80723 1 11.3301M11 1.33008C16.5228 1.33008 21 5.80723 21 11.3301M11 18.8301V21.3301M11 21.3301C16.5228 21.3301 21 16.8529 21 11.3301M11 21.3301C5.47715 21.3301 1 16.8529 1 11.3301M3.5 11.3301H1M21 11.3301H18.5M18.0784 18.4085L16.3047 16.6348M3.92163 18.4085L5.69715 16.633M3.92163 4.33008L5.65808 6.06653M18.0784 4.33008L12.4999 9.83008M13 11.3301C13 12.4346 12.1046 13.3301 11 13.3301C9.89543 13.3301 9 12.4346 9 11.3301C9 10.2255 9.89543 9.33008 11 9.33008C12.1046 9.33008 13 10.2255 13 11.3301Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer01);
export default __webpack_public_path__ + "static/media/speedometer-01.114697e6fe29ed0ed5b4c35c3400cdba.svg";
export { ForwardRef as ReactComponent };